import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { t } from "../i18n";

const CtaBand = ({ title, highlight, text }) => {
  const navigate = useNavigate();
  const ttl = title || t("cta.title");
  const hl = highlight || t("cta.heading");
  const txt = text || t("cta.text");
  return (
    <section className="relative py-20 lg:py-24 bg-navy border-t border-white/5 overflow-hidden" data-testid="cta-band">
      <div className="absolute inset-0 bg-gradient-to-r from-gold/[0.06] via-transparent to-gold/[0.06]" />
      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.35em] text-gold font-display mb-4">{ttl}</p>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            {hl}
          </h2>
          <p className="mt-5 text-slate-400 leading-relaxed max-w-xl mx-auto">{txt}</p>
          <button
            onClick={() => navigate("/contact")}
            data-testid="cta-band-btn"
            className="mt-9 btn-gold rounded-full px-9 py-4 text-sm font-bold tracking-wider font-display inline-flex items-center gap-2"
          >
            {t("cta.button")} <ArrowRight className="h-4 w-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBand;
